<template>
  <div class="row">
    <div class="Ticket" id="Ticket">

      <!-- Comanda General -->
      <div class="pageBreak ticket-container mb-3" v-if="currentTicket == 1">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda General</h3>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont my-2">
                <h3> FOLIO:{{ orden.folio }} </h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3> FOLIO DIARIO {{orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ getDateTime() }}</h3>
              </div>
            </div>
            <div v-if="mustPrint(2)">
              <div class="row">
                <div class="col-4 d-flex justify-content-center">
                  <h3>Pastor</h3>
                </div>
                <div class="col-4 d-flex justify-content-center">
                  <h3>Molleja</h3>
                </div>
                <div class="col-4 d-flex justify-content-center">
                  <h3>Asada</h3>
                </div>
              </div>
              
              <div v-for="(comensal, idx) in Comensales" class="row mb-3" v-bind:key="idx+comensal.idComensal">
                <div class="col-4 lista-tacos">
                  <h3 v-for="(taco, idx) in comensal.TP" v-bind:key="idx+taco">
                    {{taco}}<br>
                  </h3>
                </div>
                <div class="col-4 lista-tacos">
                  <h3 v-for="(taco, idx) in comensal.TM" v-bind:key="idx+taco">
                    {{taco}}<br>
                  </h3>
                </div>
                <div class="col-4 lista-tacos">
                  <h3 v-for="(taco, idx) in comensal.TA" v-bind:key="idx+taco">
                    {{taco}}<br>
                  </h3>
                </div>
              </div>
            </div>

            <div v-if="mustPrint(9)" class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3>Platillos: </h3>
              <h3 v-for="(plat, idx) in Restop" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>
            
            <div v-if="mustPrint(5)">
              <div class="col-12 d-flex justify-content-center">
                ------------------------------
              </div>
              <div class="lista-platillos" style="padding: 0 15px 0 15px;">
                <h3>Detalles: </h3>
                <h3 v-for="(plat, idx) in Detalles.Generales" v-bind:key="idx+plat">
                  {{plat}}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center my-5">
            ------------------------------
        </div>
      </div>
      
      <!-- Comanda Tacos -->
      <div class="pageBreak ticket-container mb-3" v-if="currentTicket == 2">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>

            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Tacos</h3>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont my-2">
                <h3> FOLIO:{{ orden.folio }} </h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3> FOLIO DIARIO {{orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center tipo-consumo-container">
                <div class="tipo-consumo">
                  <p class="text-uppercase align-self-center">CONSUMO {{getConsumo(tipo)}}</p>
                    <div v-if="tipo == 'sucursal'">
                      <div class="text-center table-normal-body"><pre> Mesa #{{orden.mesa}}</pre></div>
                    </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ getDateTime() }}</h3>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex justify-content-center">
                <h3>Pastor</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Molleja</h3>
              </div>
              <div class="col-4 d-flex justify-content-center">
                <h3>Asada</h3>
              </div>
            </div>
            
            <div v-for="(comensal, idx) in Comensales" class="row mb-3" v-bind:key="idx+comensal.idComensal">
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in comensal.TP" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in comensal.TM" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
              <div class="col-4 lista-tacos">
                <h3 v-for="(taco, idx) in comensal.TA" v-bind:key="idx+taco">
                  {{taco}}<br>
                </h3>
              </div>
            </div>

          </div>
        </div>
        <div v-if="mustPrint(6)">
          <div class="col-12 d-flex justify-content-center">
            ------------------------------
          </div>
          <div class="lista-platillos" style="padding: 0 15px 0 15px;">
            <h3>Detalles: </h3>
            <h3 v-for="(plat, idx) in Detalles.Tacos" v-bind:key="idx+plat">
              {{plat}}
            </h3>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center my-5">
            ------------------------------
        </div>
      </div>

      <!-- Comanda Burros / Especiales -->
      <div class="pageBreak ticket-container mb-3" v-if="currentTicket == 3">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Burritos</h3>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont my-2">
                <h3> FOLIO:{{ orden.folio }} </h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3> FOLIO DIARIO {{orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center tipo-consumo-container">
                <div class="tipo-consumo">
                  <p class="text-uppercase align-self-center">CONSUMO {{getConsumo(tipo)}}</p>
                    <div v-if="tipo == 'sucursal'">
                      <div class="text-center table-normal-body"><pre> Mesa #{{orden.mesa}}</pre></div>
                    </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ getDateTime() }}</h3>
              </div>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Burritos" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Especiales" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

          </div>
        </div>
        <div v-if="mustPrint(7)">
          <div class="col-12 d-flex justify-content-center">
            ------------------------------
          </div>
          <div class="lista-platillos" style="padding: 0 15px 0 15px;">
            <h3>Detalles: </h3>
            <h3 v-for="(plat, idx) in Detalles.Burritos" v-bind:key="idx+plat">
              {{plat}}
            </h3>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center my-5">
            ------------------------------
        </div>
      </div>

      <!-- Comanda Cebollitas -->
      <div class="pageBreak ticket-container mb-3" v-if="currentTicket == 4">
        <div class="row rowTicket">
          <div class="col ticket">
            <div class="row">
              <div class="col-12">
                <!--    
                <img :src="logo" height="100%" width="100%" :alt="title" style="margin: auto" />
              
              <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
                <!-- </div>
          </div> -->
                <div
                  class="d-flex justify-content-center pic my-3" 
                >
                  <img :src="logo" width="280px" alt="Cerrar cuenta" />
                </div>
                <!-- <img :src="logo" :alt="title" style="margin:auto; color:black;"> -->
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 d-flex justify-content-center">
                <h3>Comanda Cebollitas</h3>
              </div>
              <div class="col-12 d-flex justify-content-center folio-cont my-2 my-2">
                <h3> FOLIO:{{ orden.folio }} </h3>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3> FOLIO DIARIO {{orden.folioDiario}}</h3>
              </div>
              <div class="col-12 d-flex justify-content-center tipo-consumo-container">
                <div class="tipo-consumo">
                  <p class="text-uppercase align-self-center">CONSUMO {{getConsumo(tipo)}}</p>
                    <div v-if="tipo == 'sucursal'">
                      <div class="text-center table-normal-body"><pre> Mesa #{{orden.mesa}}</pre></div>
                    </div>
                </div>
              </div>
              <div class="col-12 d-flex justify-content-center">
                <h3>{{ getDateTime() }}</h3>
              </div>
            </div>

            <div class="lista-platillos" style="padding: 0 15px 0 15px;">
              <h3 v-for="(plat, idx) in Cebollitas" v-bind:key="idx+plat">
                {{plat}}
              </h3>
            </div>

          </div>
        </div>
        <div v-if="mustPrint(8)">
          <div class="col-12 d-flex justify-content-center">
            ------------------------------
          </div>
          <div class="lista-platillos" style="padding: 0 15px 0 15px;">
            <h3>Detalles: </h3>
            <h3 v-for="(plat, idx) in Detalles.Cebollitas" v-bind:key="idx+plat">
              {{plat}}
            </h3>
          </div>
        </div>

        <div class="col-12 d-flex justify-content-center my-5">
            ------------------------------
        </div>
      </div>

    </div>

    <div id="NoTicket" class="col ml-5">
      <button
        @click="home"
        type="button"
        class="btn btn-secondary btn-lg waves-effect waves-light"
      >
        Inicio
      </button>
    </div>
  </div>
</template>

<script>
import Alert from "@/components/Alert.vue";
import PrintCuenta from "@/modules/printer/models/PrintCuenta.js";
import ResOrdenes from '@/modules/restaurant/models/ResOrdenes.js';

import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
  name: "PrintComanda",
  
  components:{
    ResOrdenes,
  },
  props: ["tipo", "ordenId"],
  mounted() {
       
  },
  data() {
    return {
      title: "Comanda",
      logo: "/img/WideLogo.png",
      cuentas2: [],
      orden: ResOrdenes.listAlimentosComanda(this.ordenId, this.loadItem),
      Comensales: [],
      Burritos: [],
      Cebollitas: [],
      Restop: [],
      Especiales: [],
      currentTicket: -1,
      Detalles: {
        Generales : [],
        Tacos : [],
        Burritos : [],
        Cebollitas : [],
      }
    };
  },
  components: {
    // SideMenu,
    // TopBar,
    Alert,
  },
  methods: {
    printSection() {
      this.$htmlToPaper("printSection");
    },
    calculaPrecio(precio, cantidad) {
      return parseFloat(precio) * parseFloat(cantidad);
    },
    getDetalleOrden() {
      let detalleConcepto = [];

      Object.keys(this.cuentas).forEach((current) => {
        this.cuentas[current].map((subCurrent) => {
          let cadena = `   ${
            subCurrent.cantidad
          }   ${subCurrent.nombre.toUpperCase()}   ${subCurrent.precio}`;
          detalleConcepto.push(cadena);
        });
      });
      return detalleConcepto;
    },
    home() {
      this.$router.push({ name: "ResHerisOrdenesGrid" });
    },
    loadItem(res){
      console.log("orden-comanda", res)
      this.orden = res.data.item;      
      
      let _this = this;
      console.log("tipo", this.tipo);
      console.log("orden", this.orden);
      
      if(this.orden.consumo=="sucursal"){
        this.separarComandas(res.data.item.resPlatos)        
      }else{
        this.separarTacos(res.data.item.resPlatos)        
      }   
    },
    getConsumo(id){
      if(id == "llevar"){
        return "para llevar"
      }
      if(id == "recoger"){
        return "para recoger"
      }
      if(id == "sucursal"){
        return "en sucursal"
      }
      return "a domicilio"
    },
    print() {
      this.selectText();
      let selection = window.getSelection();
      console.log(selection.toString());

      setTimeout(function () {
        window.print();
      }, 2000);
    },
    selectText() {
      let id = "Ticket";
      var sel, range;
      var el = document.getElementById(id); //get element id
      if (window.getSelection && document.createRange) {
        //Browser compatibility
        sel = window.getSelection();
        if (sel.toString() == "") {
          //no text selection
          window.setTimeout(function () {
            range = document.createRange(); //range object
            range.selectNodeContents(el); //sets Range
            sel.removeAllRanges(); //remove all ranges from selection
            sel.addRange(range); //add Range to a Selection.
          }, 1);
        }
      } else if (document.selection) {
        //older ie
        sel = document.selection.createRange();
        if (sel.text == "") {
          //no text selection
          range = document.body.createTextRange(); //Creates TextRange object
          range.moveToElementText(el); //sets Range
          range.select(); //make selection.
        }
      }
    },
    guardar() {
      // var ePosDev = new epson.ePOSDevice();
      // console.log(ePosDev);
      // this.$htmlToPaper('printMe');

      // html2canvas(document.body).then(function (canvas) {
      //   var imgData = canvas.toDataURL("image/jpeg", 1.0);
      //   var pdf = new jsPDF("p", "mm", [400, 480]);
      //   pdf.addImage(imgData, "JPEG", 0, 0, 400, 480);
      //   pdf.save("screen-3.pdf");
      // });

      // var pdf = new jsPDF("p", "mm", "a4");
      // pdf.html(document.getElementById("Ticket"), {
      //   callback: function (pdf) {
      //     pdf.save("a4.pdf");
      //   },
      // });

      // const doc = new jsPDF();
      // const contentHtml = this.$refs.content.innerHTML;
      // doc.fromHTML(contentHtml, 15, 15, {
      //   width: 170,
      // });
      // doc.save("sample.pdf");

      // ***************************************************************************************
      let prtHtml = document.querySelector("#Ticket").innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );

      WinPrint.document.write(`<!DOCTYPE html>
         <html>
         <head>
            <link rel="stylesheet" href="http://localhost:8080/css/boostrap.min.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/hamburguesa.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/style.css/">
            <link rel="stylesheet" href="http://localhost:8080/css/my_style.css/">
        <style>
        * {
            background: white !important;
            color: black !important;
          }
        </style>
        </head>
        
        <body>
        ${prtHtml}
        </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      // setTimeout(function(){
      // WinPrint.print();
      // WinPrint.close(); }, 2000);

      // WinPrint.print();
      // WinPrint.close();
      let bodyFormData = new FormData();
      bodyFormData.append("html", WinPrint);

      let params = {
        html: bodyFormData,
      };
      console.log("BodyFormData");
      console.log(bodyFormData);
      PrintCuenta.pagarV2(bodyFormData, (resPDF) => {
        let pdfWindow = window.open("");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf, " +
            escape(resPDF.data) +
            "'></iframe>"
        );
      });
    },
    comandaLocal(){

      setTimeout(()=>{
        this.currentTicket = 2;
        setTimeout(()=>{
          if(this.mustPrint(this.currentTicket))
            window.print()
        }, 150);

        setTimeout(()=>{
          this.currentTicket = 3;
          setTimeout(()=>{
            if(this.mustPrint(this.currentTicket))
              window.print()
          }, 150);

          setTimeout(()=>{
            this.currentTicket = 4;
            setTimeout(()=>{
                if(this.mustPrint(this.currentTicket))
                  window.print()

                setTimeout(()=>{
                  window.close()
                }, 300);
              }, 150);

            }, 1450);
        }, 1100);
      }, 1000);

    },
    comandaGenerica(){
      setTimeout(()=>{
        this.currentTicket = 1;
        setTimeout(()=>{
          if(this.mustPrint(9) || this.mustPrint(2)){
            window.print()
          }
          setTimeout(()=>{
            window.close()
          }, 300);
        }, 300);
      }, 750);
    },
    separarTacos(ordenes){
      ordenes.forEach((element) => {
        var nombre = element.alimento.nombre
        switch(nombre){
          case "taco de asada":
            this.addPlatoComensal(element.comensal, 0, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de asada con queso":
            this.addPlatoComensal(element.comensal, 1, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de pastor":
            this.addPlatoComensal(element.comensal, 2, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de pastor con queso":
            this.addPlatoComensal(element.comensal, 3, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de molleja":
            this.addPlatoComensal(element.comensal, 4, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de molleja con queso":
            this.addPlatoComensal(element.comensal, 5, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de pastor con piña":
            this.addPlatoComensal(element.comensal, 6, element.cantidad+" P")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" P", element.detalles)
            break;
          case "taco de pastor con piña y queso":
            this.addPlatoComensal(element.comensal, 7, element.cantidad+" P & C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+"P & C/Q", element.detalles)
            break;
          default:
            if(! (nombre.includes("agua ") || nombre.includes("refresco")) ){
              this.Restop.push(element.cantidad+" "+nombre)
              this.addDetails(this.Detalles.Generales, element.cantidad+" "+nombre, element.detalles)
            }
        }
      })
      this.comandaGenerica()
    },
    separarComandas(ordenes){
      ordenes.forEach((element) => {
        var nombre = element.alimento.nombre
        switch(nombre){
          case "taco de asada":
            this.addPlatoComensal(element.comensal, 0, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de asada con queso":
            this.addPlatoComensal(element.comensal, 1, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de pastor":
            this.addPlatoComensal(element.comensal, 2, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de pastor con queso":
            this.addPlatoComensal(element.comensal, 3, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de molleja":
            this.addPlatoComensal(element.comensal, 4, element.cantidad)
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre, element.detalles)
            break;
          case "taco de molleja con queso":
            this.addPlatoComensal(element.comensal, 5, element.cantidad+" C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" C/Q", element.detalles)
            break;
          case "taco de pastor con piña":
            this.addPlatoComensal(element.comensal, 6, element.cantidad+" P")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+" P", element.detalles)
            break;
          case "taco de pastor con piña y queso":
            this.addPlatoComensal(element.comensal, 7, element.cantidad+" P & C/Q")
            this.addDetails(this.Detalles.Tacos, element.cantidad+" "+nombre+"P & C/Q", element.detalles)
            break;
          default:
            if(nombre.includes("burrito")){
              this.Burritos.push(element.cantidad+" "+nombre)
              this.addDetails(this.Detalles.Burritos, element.cantidad+" "+nombre, element.detalles)
            }
            else if(nombre.includes("cebollitas")){
              this.Cebollitas.push(element.cantidad+" "+nombre)
              this.addDetails(this.Detalles.Cebollitas, element.cantidad+" "+nombre, element.detalles)
            }
            else if(! (nombre.includes("agua ") || nombre.includes("refresco")) ){
              this.Especiales.push(element.cantidad+" "+nombre)
              this.addDetails(this.Detalles.Burritos, element.cantidad+" "+nombre, element.detalles)
            }
        }
      })
      this.comandaLocal()
    },
    getDateTime(){
      let date = new Date();

      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();
      let hour = date.getHours();
      let minute = date.getMinutes();
      if(minute < 10){
        minute = `0${minute}`
      }
      let dateTime;
      if (month < 10) {
        dateTime = `${day}-0${month}-${year} ${hour}:${minute}`;
      } else {
        dateTime = `${day}-${month}-${year} ${hour}:${minute}`;
      }
      return dateTime.toString()
    },
    mustPrint(num){
      switch(num){
        case 2:
          return this.Comensales.length > 0
        case 3:
          return this.Burritos.length > 0 ||
                 this.Especiales.length > 0
        case 4:
          return this.Cebollitas.length > 0
        case 5:
          return this.Detalles.Generales.length > 0 
        case 6:
          return this.Detalles.Tacos.length > 0
        case 7:
          return this.Detalles.Burritos.length > 0
        case 8:
          return this.Detalles.Cebollitas.length > 0
        case 9:
          return this.Restop.length > 0
      }
    },
    addDetails(Arreglo, Str, Details){
      if(Details != ""){
        Arreglo.push(Str+", "+Details)
      }
    },
    addPlatoComensal(comensalId, type, str){
      var comensal = this.getComensal(comensalId)
      if(comensal == null){
        comensal = {
          idComensal: comensalId,
          TA: [],
          TP: [],
          TM: [],
        }
        this.Comensales.push(comensal)
      }
      switch(type){
        case 0:
          comensal.TA.push(str)
          break;
        case 1:
          comensal.TA.push(str)
          break;
        case 2:
          comensal.TP.push(str)
          break;
        case 3:
          comensal.TP.push(str)
          break;
        case 4:
          comensal.TM.push(str)
          break;
        case 5:
          comensal.TM.push(str)
          break;
        case 6:
          comensal.TP.push(str)
          break;
        case 7:
          comensal.TP.push(str)
          break;  
      }
    },
    getComensal(id){
      if(this.Comensales.length == 0){
        return null
      }else{
        var comensal = this.Comensales.find(e => e.idComensal == id)
        if(comensal == undefined){
          return null
        }
        return comensal
      }
    },
  },

};
</script>

<style scoped>
* {
  background: white !important;
  color: black !important;
  font-weight: bolder !important;
  font-size: 16px !important;
  font-family: 'Fira Code', monospace;
  text-transform: uppercase;
}
.rowTicket {
  padding-left: 10px;
}
/* .ticket {
  width: 80mm;
  border: 1px solid black;
  padding-left: 15px;
  margin-left: 16px;
} */

h1,
h2,
h3 {
  margin: 0;
}

h1 {
  font-size: 20px;
  font-family: "Times New Roman", Times, serif;
}
h2,
h3,
h4,
.detalle,
table,
th,
td {
  font-size: 16px !important;
  font-family: 'Fira Code', monospace;
  text-transform: uppercase;
}
.detalle {
  /* padding: 0!important; */
  margin: 0 auto;
}
.lista-tacos{
  text-align: center;
}

pre{
  all: initial;
  font-size: 12px !important;
  font-family: 'Fira Code', monospace;
  font-weight: bolder !important;
  text-transform: uppercase;
  color: black;
}

.tipo-consumo-container{
  border-top: 2px dashed black;
  border-bottom: 2px dashed black;
  margin: 8px 0;
}
.tipo-consumo{
  padding-top: 8px;
  padding-bottom: 8px;
}
.tipo-consumo > p{
  font-size: 20px !important;
  font-weight: bolder !important;
  margin-bottom: 4px;
}
.table-bold-header{
  font-weight: bolder !important;
}
.table-normal-body{
  font-weight: 500 !important;
}
.dashed-top{
  border-top:2px dashed black;
}

.folio-cont > h3{
  font-size: 22px !important;
}
@media print {
  * {
    background: white !important;
    color: black !important;
    /* font-size: 14px; */
  }

  .folio-cont > h3{
    font-size: 22px !important;
  }
  #NoTicket {
    display: none;
  }
  .ticket-container{
    width: 100%;
    margin-left: 0;
  }
  .Ticket {
    background-color: white;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 18px;
    font-size: 22px;
    line-height: 18px;
    position: fixed;
  }
  .pic
  {
    margin-top: 10px; 
    margin-bottom: 5px;
  }
  .pic img {
    width: 80%;
  }
  .rowTicket {
    /* padding-left: 10px; */
    padding: 0;
    /* height: 100%; */
  }
  .ticket {
    /* width: 80mm; */
    /* border: 1px solid black; */
    /* border:  none; */
    /* padding-left: 15px;
    margin-left: 16px; */
  }

  h1,
  h2,
  h3 {
    margin: 0;
  }

  h1 {
    font-size: 20px;
    font-family: 'Fira Code', monospace;
  }
  h2,
  h3,
  h4,
  .detalle,
  table,
  th,
  td,
  pre {
    font-size: 20px !important;
    font-family: 'Fira Code', monospace;
    text-transform: uppercase;
    font-weight: bolder !important;
  }
  .pre{
    font-weight: bolder !important;
  }
  .detalle {
    /* padding: 0!important; */
    margin: 0 auto;
  }
  .pageBreak {
    page-break-before : always;
    page-break-after: always;
    clear: both;
  }
  .table-bold-header{
    font-weight: bolder !important;
  }
  .table-normal-body{
    font-weight: 500 !important;
  }
}
</style>